import { render, staticRenderFns } from "./WareneingangEntwicklungView.vue?vue&type=template&id=2bfb68b4&"
import script from "./WareneingangEntwicklungView.vue?vue&type=script&lang=js&"
export * from "./WareneingangEntwicklungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports